import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[sag-ui-dialog-insertion]',
})
export class InsertionDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
